<template>
  <div v-if="address.email || address.contact_phone">
    <div v-if="address.email" class="mb-3">
      <strong>Email:</strong> <a :href="`mailto:${address.email}`">{{ address.email }}</a>
    </div>
    
    <div v-if="address.contact_phone" class="mb-3">
      <strong>Phone:</strong> <a :href="`tel:${address.contact_phone}`">{{ address.contact_phone }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressContactInfo',
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
};
</script>